import ListingCategory from './listing-category';
import ListingLabel from './listing-label';
import filterObject from '../utils/filter-object';
export var ListingTypeName;
(function (ListingTypeName) {
  ListingTypeName["RENTAL_RESIDENTIAL"] = "RENTAL_RESIDENTIAL";
  ListingTypeName["SALES_RESIDENTIAL"] = "SALES_RESIDENTIAL";
  ListingTypeName["RENTAL_COMMERCIAL"] = "RENTAL_COMMERCIAL";
  ListingTypeName["SALES_COMMERCIAL"] = "SALES_COMMERCIAL";
  ListingTypeName["SALES_BUSINESS"] = "SALES_BUSINESS";
  ListingTypeName["SHARE_RESIDENTIAL"] = "SHARE_RESIDENTIAL";
  ListingTypeName["DEVELOPMENTS_RESIDENTIAL"] = "DEVELOPMENTS_RESIDENTIAL";
  ListingTypeName["OFF_MARKET"] = "OFF_MARKET";
  ListingTypeName["SALES_EARLY_ACCESS"] = "SALES_EARLY_ACCESS";
})(ListingTypeName || (ListingTypeName = {}));
var ListingTypeValues = {
  RENTAL_RESIDENTIAL: {
    name: ListingTypeName.RENTAL_RESIDENTIAL,
    label: 'Residential Rental Listings',
    isCommercial: false,
    titleFlavour: 'For Rent',
    category: ListingCategory.RENT,
    siteContext: 'RENT_RESIDENTIAL',
    pageContext: 'rent-residential',
    shortLabel: ListingLabel.RENTAL,
    pastParticiple: 'rented',
    urlContext: 'rent'
  },
  SALES_RESIDENTIAL: {
    name: ListingTypeName.SALES_RESIDENTIAL,
    label: 'Residential Sale Listings',
    labelPast: 'Residential Sold Listings',
    isCommercial: false,
    titleFlavour: 'For Sale',
    category: ListingCategory.BUY,
    siteContext: 'BUY_RESIDENTIAL',
    pageContext: 'sale-residential',
    shortLabel: ListingLabel.SALES,
    pastParticiple: 'sold',
    urlContext: 'sale'
  },
  RENTAL_COMMERCIAL: {
    name: ListingTypeName.RENTAL_COMMERCIAL,
    label: 'Commercial Rental Listings',
    isCommercial: true,
    titleFlavour: 'For Lease',
    category: ListingCategory.RENT,
    siteContext: 'RENT_COMMERCIAL',
    pageContext: 'rent-commercial',
    shortLabel: ListingLabel.RENTAL,
    pastParticiple: 'rented',
    urlContext: 'commercial-lease'
  },
  SALES_COMMERCIAL: {
    name: ListingTypeName.SALES_COMMERCIAL,
    label: 'Commercial Sale Listings',
    labelPast: 'Commercial Sold Listings',
    isCommercial: true,
    titleFlavour: 'For Sale',
    category: ListingCategory.BUY,
    siteContext: 'BUY_COMMERCIAL',
    pageContext: 'sale-commercial',
    shortLabel: ListingLabel.SALES,
    pastParticiple: 'sold',
    urlContext: 'commercial-sale'
  },
  SALES_BUSINESS: {
    name: ListingTypeName.SALES_BUSINESS,
    label: 'Business Sales',
    labelPast: 'Business Sold',
    isCommercial: true,
    titleFlavour: 'For Sale',
    category: ListingCategory.BUY,
    siteContext: 'BUY_BUSINESS',
    pageContext: 'sale-business',
    shortLabel: ListingLabel.SALES,
    pastParticiple: 'sold',
    urlContext: 'commercial-business'
  },
  SHARE_RESIDENTIAL: {
    name: ListingTypeName.SHARE_RESIDENTIAL,
    label: 'Residential Share Listings',
    isCommercial: false,
    titleFlavour: 'To Share',
    category: ListingCategory.SHARE,
    siteContext: 'SHARE_RESIDENTIAL',
    pageContext: 'share-residential',
    shortLabel: ListingLabel.SHARE,
    pastParticiple: 'rented',
    urlContext: 'share'
  },
  DEVELOPMENTS_RESIDENTIAL: {
    name: ListingTypeName.DEVELOPMENTS_RESIDENTIAL,
    label: 'New Homes',
    labelPast: 'New Homes Sold',
    isCommercial: false,
    titleFlavour: 'For Sale',
    category: ListingCategory.DEVELOPMENTS,
    siteContext: 'DEVELOPMENTS_RESIDENTIAL',
    pageContext: 'developments-residential',
    pageContextOther: 'new-homes-residential',
    shortLabel: ListingLabel.SALES,
    pastParticiple: 'sold',
    urlContext: 'new-homes'
  },
  OFF_MARKET: {
    name: ListingTypeName.OFF_MARKET
  },
  SALES_EARLY_ACCESS: {
    name: ListingTypeName.SALES_EARLY_ACCESS,
    label: 'Early Access Sale Listings',
    isCommercial: false,
    titleFlavour: 'For Sale',
    category: ListingCategory.BUY,
    siteContext: 'BUY_RESIDENTIAL',
    pageContext: 'sale-early-access',
    shortLabel: ListingLabel.SALES,
    pastParticiple: 'sold',
    urlContext: 'sale'
  }
};
var ListingType = ListingTypeValues;
export var CommercialListingTypes = filterObject(ListingType, each => each.isCommercial);
export var ResidentialListingTypes = filterObject(ListingType, each => !each.isCommercial);
export var SaleListingTypes = filterObject(ListingType, each => each.category === ListingCategory.BUY);
export var RentListingTypes = filterObject(ListingType, each => each.category === ListingCategory.RENT);
export var OnMarketListingTypes = filterObject(ListingType, each => each.name !== 'OFF_MARKET' && each.name !== 'SALES_EARLY_ACCESS');
export var AllExceptBusinessListingTypes = filterObject(OnMarketListingTypes, each => each.name !== 'SALES_BUSINESS');
export var SaleListingTypeNames = Object.keys(SaleListingTypes);
export var RentListingTypeNames = Object.keys(RentListingTypes);
export var ResidentialListingTypeNames = Object.keys(ResidentialListingTypes);
export var CommercialListingTypeNames = Object.keys(CommercialListingTypes);
export var ListingTypeNames = Object.keys(ListingType);
export var SaleListingTypeKeys = Object.keys(SaleListingTypes);
export var RentListingTypeKeys = Object.keys(RentListingTypes);
export var ResidentialListingTypeKeys = Object.keys(ResidentialListingTypes);
export var CommercialListingTypeKeys = Object.keys(CommercialListingTypes);
export var AllExceptBusinessListingTypeKeys = Object.keys(AllExceptBusinessListingTypes);
export var ListingTypeKeys = Object.keys(ListingType);
export var intersectionalNames = function intersectionalNames() {
  for (var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++) {
    types[_key] = arguments[_key];
  }
  return types.length === 0 ? [] : types.reduce((resultSet, type) => resultSet.filter(each => type[each]), Object.keys(ListingType));
};
export var ListingTypeByPageContext = Object.keys(ListingType).reduce((map, listingTypeKey) => {
  var listingType = ListingType[listingTypeKey];
  if (listingType.pageContext) {
    map[listingType.pageContext] = listingType.name;
  }
  return map;
}, {});
export default ListingType;